/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — the «UI nuova» frame of the public shop (M18
 *              ec-shell): top band (logo, shop name, sections, languages,
 *              Area personale, cart), phone bottom tab bar, main column around
 *              the route outlet (yield), footer badge, the menu and cart
 *              BbPanels and the «not available online» contact dialog.
 *              Forked in templates/application.hbs with `(ui-is-nuova)`.
 *   extends:   Component (@glimmer/component)
 *   template:  ec-shell-nuova.hbs
 *   args:      @c (the application controller: every getter, action and task
 *              is the classic one — showMenu, showCart, totCart, cart,
 *              delCart, gotoMenu, openCartFromMenu, switchLangTask,
 *              noDispoOnline, sendContactMailTask …)
 *   uses:      service:intl (current locale when no `?lang=` is set)
 *   siblings:  ec-shell-nuova/lang.hbs (language dropdown with flags, NvLangMenu),
 *              ec-shell-nuova/contact-mail.hbs (contact dialog),
 *              list-cart-product-nuova (cart lines)
 *   tests:     ui-nuova-ec-shell-test.js
 *   gotchas:   presentation getters only (controllers/application.js is a
 *              frozen god file). The outlet keeps the classic `content-wrap
 *              lang-<lang>` and `main-panel` classes: WrapTranslation and the
 *              pages' responsive toggles (.main-panel .dateSelected) key on
 *              them.
 */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class EcShellNuovaComponent extends Component {
  @service intl;

  // Two-letter code of the language shown, for the current row of the language dropdown: the `?lang=` query param
  // once switchLangTask ran (lower case), else the locale the intl service resolved at boot.
  get langCode() {
    const lang = this.args.c?.lang || this.intl?.primaryLocale || '';
    return String(lang).slice(0, 2).toLowerCase();
  }

  // The tenant uploaded a logo (the controller's thumbnail_url falls back to the Beebeeboard logo, which nuova
  // replaces with the shop's initial).
  get hasLogo() {
    return Boolean(this.args.c?.content?.open_organization?.thumbnail_url);
  }
}
